<template>
    <div class="page-home">
        
        <div class="page-cotent">
            <div class="img-box">
                <img :src="source_prefix + topUrl" alt="" class="top-img">
                <div class="jinglli-box" @click="showjiangli">
                    <div > <i class="el-icon-present"></i>赛事奖励</div>
                </div>
                <div class="tab-box">
                <el-button  type="danger" plain  style="width:50%;margin:0 auto;" round>个人成绩榜</el-button>
                </div>
            </div>
     
            <div class="list-box">
                <template>
                    <el-table
                        :data="list"
                        :header-cell-style="{}"
                        style="width: 100%">
                        <el-table-column
                            label="排名"
                            align="center"
                            class="table-heard"
                            >
                            <template slot-scope="scope">
                                {{scope.row.rank}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            class="table-heard"
                            label="昵称">
                            <template slot-scope="scope">
                                {{scope.row.user_name}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            class="table-heard"
                            label="用时">
                            <template slot-scope="scope">
                                {{scope.row.use_time}} S
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            class="table-heard"
                            label="总分">
                            <template slot-scope="scope">
                                {{scope.row.score}} 分
                            </template>
                        </el-table-column>
       
                    </el-table>

                    <div class="user-rank-box">
                        <el-row>
                            <el-col :span="6">{{user_ranking.rank}}</el-col>
                            <el-col :span="6">{{user_ranking.user_name}}</el-col>
                            <el-col :span="6">{{user_ranking.use_time}} S</el-col>
                            <el-col :span="6">{{user_ranking.score}} 分</el-col>
                        </el-row>
                    </div>
                </template>
   
            </div>
        
        </div>
       

        <el-dialog
            title="活动奖励"
            :visible.sync="dialogjiangli"
            width="600px"
            :before-close="handleClose">
            <div v-if="awardData.active_status == 2" class="jiangli-box">
                <div class="jiangli-img-box">
                    <img class="jiangli-img" :src="source_prefix + jinxingzhongImg" alt="">
                </div>
                <div class="active-status-text">比赛进行中！</div>
                <div class="active-tips">成绩暂未公布，请耐心等待结果</div>
            </div>

            <div v-if="awardData.active_status == 10 && awardData.award_list.length == 0" class="jiangli-box">
                <div class="jiangli-img-box">
                    <img class="jiangli-img" :src="source_prefix + yihanImg" alt="">
                </div>
                <div class="active-status-text">比赛已结束！</div>
                <div class="active-tips">您在本次竞赛中未能获奖，请继续努力！</div>
            </div>

            <div v-if="awardData.active_status == 10 && awardData.award_list.length !== 0" class="jiangli-box">
                <div class="jiangli-img-box">
                    <img class="jiangli-img" :src="source_prefix + successImg" alt="">
                </div>
                <div class="active-status-text">比赛已结束！</div>
                <div class="active-tips"   v-for="(item, index) in awardData.award_list" :key="index" v-if="item.type == 'score'">
                    <div >恭喜您在本次竞赛中获得个人成绩  <span style="color:#D24531">第{{item.rank}}名</span>  的好成绩</div>
                    <!-- <div v-if="item.type == 'favor'">恭喜您在本次竞赛中获得个人点赞  <span style="color:#D24531">第{{item.rank}}名</span>  的好成绩</div> -->
                </div>
            </div>

        </el-dialog>
        <Waterfall ref="Waterfall" :dataList = "dataList" :list="list" :form="form"></Waterfall>
    </div>


</template>

<script>
    import { getActivityRanking, getUserActiveAward} from '@/api'
    import store from '@/store'
    import Waterfall from '@/components/waterfall'

    export default {
        name: 'Examination',
        components: {
            Waterfall
        },
        props: ['cate', 'words'],
        data() {
            return {
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
                topUrl:"/jingying/word/2024/11/21/8b632f87b6577ccd9b953cc7c2f27a2c.png",
                dialogjianjie:false,
                dialogjiangli:false,
                activeData:{},
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                form:{
                    active_guid:"",
                    page:1,
                    limit:20,
                    type: "score"

                },
                signFlag:false,
                status:1,
                status_name:"",
                activeText:"活动未开始",
                currentTimeStamp:0,
                has_tested:false,
                user_data :{},
                intervalId:0,
                tableData:[],
                list:[],
                user_ranking:{},
                awardData:{
                    active_status:1,
                    award_list:[],
                    award_str:[]
                },
                jinxingzhongImg:"/jingying/word/2024/11/22/bca4923bde8136193469e04e5aaf6cab.png",
                successImg:"/jingying/word/2024/11/22/11220d5e34b0dd9d8cf21a3ea1c08c4d.png",
                yihanImg:"/jingying/word/2024/11/22/b2889bbd579c45e4455c0813c0467900.png",
            }
         
        },
        computed: {
        },
        methods: {
            handleClose()
            {
                this.dialogjianjie = false
                this.dialogjiangli = false
            },
            showjianjie()
            {
                this.dialogjianjie = true
            },
            showjiangli()
            {
                // var paramData = {
                //     active_guid : "c569ece0afce11ec945c00ffb2727697"
                // }

                var paramData = {
                    active_guid : this.activeData.active_guid
                }
                getUserActiveAward(paramData).then(response => {

                    this.awardData = response
                    this.dialogjiangli = true
                })

                
            },
            dataList(clearFlag)
            {
                if(clearFlag === true)
                {
                    this.list = []
                    this.form.page = 1
                }

                getActivityRanking(this.form).then(response => {

                    if(response.data.length != 0)
                    {
                        this.list = this.list.concat(response.data)
                        this.$refs.Waterfall.isLoading = false
                    }
                    this.user_ranking = response.user_ranking
               
                })
            },

 
      
        },

        created(){
            var that = this
            
            store.dispatch('common/loadActiveData');
            this.activeData = store.state.common.activeData
            this.form.active_guid = this.activeData.active_guid

            this.dataList()



        },
        beforeUnmount() {
        
        },
        beforeDestroy() {
            
        },
        mounted() {
          

        }
    }
</script>
<style scoped lang="less">

    .page-cotent{
        width: 600px;
        margin : 0 auto;
      
    }

    .jiangli-box{
        padding:0 10%;
    }

    .jiangli-img-box{
        width: 60%;
        margin: 0 auto;
    }
    .jiangli-img{
        width: 100%;
    }
    .active-status-text{
        color: #333333;
        height:50px;
        line-height: 50px;
        font-size: 26px;
    }

    .active-tips{
        color: #999999;
        height:50px;
        line-height: 50px;
        
    }

    .tab-box{
        text-align: center;
        position: absolute;
        bottom: 100px;
        width: 100%;
    }
    .img-box{
        position: relative;
    }

    .top-img{
        width:100%;
    }

    .list-box{
        width: 100%;
        min-height:50vh;
        background-color: #ffffff;
        border: 1 solid #fff;
        border-radius: 50px;
        position: relative;
        top: -50px;
        padding: 20px 30px;
        margin: 0;
    }
    .user-rank-box {
        position: absolute;
        bottom: 0px;
        width: 100%;
        text-align: center;
        left: 0;
        height: 50px;
        line-height: 50px;
        background-color: #ccc;
    }

    .page-home{
        min-height:80vh;
        background: #F2F6FC;
    }

    .status-name{
        height:30px;
        line-height: 30px;
    }

    .status-true{
        color:#FD413A;
    }
    .status-false{
        color:#999999;
    }

    .active-top{
        margin-top:50px;
    }

    .active-jianjie{
        width: 90%;
 
        color: #1796EF;
        background-color: #fff;
        padding:30px 0;
        cursor: pointer;
    }

    .active-jiangli{
        width: 90%;
 
        color: #1796EF;
        background-color: #fff;
        padding:30px 0;
        cursor: pointer;
    }

    .jinglli-box{
        cursor: pointer;
        position: absolute;
        top:50px;
        right: 50px;
        color:#fff;
        border: 2px solid #fff;
        padding:5px 20px;
        border-radius: 20px;
        z-index: 99;
    }

    .user-box{
        margin-top: 20px;
        background: #fff;
        padding: 30px 40px;

    }
    .user-avatar-box{
        width: 80%;
    }
    .user-avatar{
        border: 1px #fff solid;
        border-radius: 100px;
    }

    .user-content{
        padding-left: 30px;
        text-align: left;
    }

    .user-name{
        color: #333333;
        margin-top:10px;
        font-size: 24px;
    }

    .user-id{
        color: #999999;
        margin-top:20px;
        font-size: 20px;
    }

    .user-school{
        color: #999999;
        margin-top:20px;
        font-size: 20px;
    }
    .table-box{
        margin-top:30px;
    }
    .table-heard{
        background-color: #1796EF ;
        color: #ffffff;
    }


    

    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
    .top-title{
        text-align: center;
        font-size:24px;
        margin-top:3vh;
    }


    @media (max-width: 1400px) {
  
    }

</style>
